import { render } from "./GeneralInfoReservation.vue?vue&type=template&id=4644c998&scoped=true&ts=true"
import script from "./GeneralInfoReservation.vue?vue&type=script&lang=ts"
export * from "./GeneralInfoReservation.vue?vue&type=script&lang=ts"

import "./GeneralInfoReservation.vue?vue&type=style&index=0&id=4644c998&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4644c998"]])

export default __exports__